export default {
    student: [],
    active_student: []
}